import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ProvidersService } from '../../providers/providers.service';
import { ReservationService } from '../reservations.service';
import { Subscription } from 'rxjs/Subscription';
import { CompaniesEnum } from 'app/core/enums/companies.enum';
import { excludedProviderAlertOptions, ValidateTotalMilesLyft } from '../../../utils/helpers';
import * as moment from 'moment';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { PayorsService } from 'app/pages/payors/payors.service';

@Component({
  selector: 'app-reservation-change-provider',
  templateUrl: './reservation-change-provider.component.html',
  styleUrls: ['./reservation-change-provider.component.scss']
})
export class ReservationChangeProviderComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {

  @Input() riderId = 0;
  @Input() companyId = 0;
  @Input() totalMiles: number;
  @Input() tripId = 0;
  @Input() payorId = 0;
  @Input() hasExcludeProviders = false;
  @Input() isStandingOrder: boolean;
  @Input() standingOrderId: number;
  @Input() standingOrderDate: any;
  @Output() response = new EventEmitter < any > ();
  @Output() emitterResponse: EventEmitter<boolean> = new EventEmitter<boolean>();
  private selectedProvider = 0;
  private selectedRiderId = 0;
  private companies: any[];
  private excludedProviders: { providerid: number, company: { speedcode: string } }[] = [];
  private disableButton = false;
  private observables: Subscription[] = [];
  private isPosting = false;

  date: any;
  dateRange = {
    startdatechanges: '',
    enddatechanges: ''
  };

  constructor(
    protected service: ReservationService,
    protected providerService: ProvidersService,
    private loading_: T2LoadingService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
    protected payorService: PayorsService,
  ) {
    super('app-edit-reservation-form', Inject);
  }

  ngOnInit() {
    this.getAllProvider();
    this.loadExcludedProviders();

    if (this.companyId !== 0) {
      this.selectedProvider = this.companyId;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['companyId']) {
      this.selectedProvider = this.companyId;
    }

    if (changes['standingOrderDate'] && this.standingOrderDate) {
      this.date = this.standingOrderDate;
    }

    if (changes['riderId'] && this.riderId) {
      this.selectedRiderId = this.riderId;
    }
  }

  /**
   * get all companpies from server
   */
  private getAllProvider(): void {
    if (this.selectedRiderId > 0) {
      const riderId = this.selectedRiderId;
      this.observables.push(
      this.providerService.getCompaniesByRider(riderId).subscribe(
        data => {
          this.companies = data;
        }
      ));
    } else {
      this.observables.push(
      this.providerService.getCompanies('all').subscribe(
        data => {
          this.companies = data;
        }
      ));
    }
  }

  private loadExcludedProviders(): void {
    if (!this.payorId || !this.hasExcludeProviders) { return; }
    this.observables.push(
      this.payorService.getExcludeProvVyPayor(this.payorId).subscribe({
        next: (data) => this.excludedProviders = data || [],
        error: (err) => this.sweetAlertHelper.captureException(err)
      })
    );
  }

  onSelectProvider(providerId: number): void {
    const excludedProvider = this.excludedProviders.find((row) => row.providerid === providerId);
    if (excludedProvider && providerId !== this.companyId) {
      this.sweetAlertHelper.createCustomAlert(excludedProviderAlertOptions(excludedProvider.company.speedcode));
    }
  }

  verifyTotalMilles() {
    if (
      this.selectedProvider === CompaniesEnum.Lyft &&
      ValidateTotalMilesLyft(this.totalMiles)
    ) {
      this.sweetAlertHelper.createCustomAlert({
          title: 'Lyft 50 Miles',
          html: `<div>
            <p>This trip is over 50 miles, do you want to assign to Lyft ?</p><br>
          </div>`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#FF0000',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes',
        })
        .then((result: any) => {
          if (result.value) {
            this.saveProvider();
          }
        });
    } else {
      this.saveProvider();
    }
  }

  /**
   * save company action
   */
  protected saveProvider() {
    if (this.isPosting && !this.isAllowedAction('PostTripAssignmentSO')) {
      return this.sweetAlertHelper.createCustomAlert({
        title: 'Permission Error',
        text: 'You do not have permission to open reservation',
        type: 'error'
      });
    }

    this.disableButton = true;
    this.loading_.show();
    if (this.isStandingOrder) {
      this.setAllLeg().then(allLegs => {
        const object = {
          companyid: this.selectedProvider,
          standingorderTripid: this.tripId,
          allLegs: allLegs.value ? true : false,
          startdatechanges: this.dateRange.startdatechanges,
          enddatechanges: this.dateRange.enddatechanges,
          isPosting: this.isPosting
        };
        this.observables.push(
          this.service.changeStandingOrderCompany(object).finally(() => {
            this.loading_.hiden();
          }).subscribe(
            data => {
              this.disableButton = false;
              this.sweetAlertHelper.createCustomAlert({title: 'Succes', text: data.message, type: 'success'})
                .then(() => {
                  data.newValue = this.selectedProvider;
                  this.response.emit(data);
                  this.emitterResponse.emit(true);
                });
            },
            err => {
              this.disableButton = false;
              this.sweetAlertHelper.createCustomAlert({title: 'Error change provider', text: err.message, type: 'error'})
                .then(() => {
                  this.response.emit(err);
                  this.emitterResponse.emit(false);
                });
            }
          ));
      });
    } else {
      this.observables.push(
        this.service.editCompany({
          tripid: this.tripId,
          oldvalue: this.companyId,
          newvalue: this.selectedProvider
        }).finally(() => {
          this.loading_.hiden();
        }).subscribe(
          data => {
            this.disableButton = false;
            this.sweetAlertHelper.createCustomAlert({title: 'Succes', text: data.message, type:'success'})
              .then(() => {
                data.newValue = this.selectedProvider;
                this.response.emit(data);
                this.emitterResponse.emit(true);
              });
          },
          err => {
            this.disableButton = false;
            this.sweetAlertHelper.createCustomAlert({title: 'Error changing provider.', text: err.message, type: 'warning'})
              .then(() => {
                this.response.emit(err);
                this.emitterResponse.emit(false);
              });
          }
        ));
    }
  }

  setAllLeg() {
    return this.sweetAlertHelper.createCustomAlert({
      text: 'Do you want to change the provider for all legs?',
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    });
  }

  onDateChanged(event) {
    if (event) {
      if (this.date.formatted) {
        const splitDate = this.date.formatted.split(' ');
        this.dateRange = {
          startdatechanges: splitDate[0],
          enddatechanges: splitDate[2]
        };
      } else {
        const startDate = `${this.date.beginDate.year}-${this.date.beginDate.month}-${this.date.beginDate.day}`;
        const endDate = `${this.date.endDate.year}-${this.date.endDate.month}-${this.date.endDate.day}`;
        this.dateRange = {
          startdatechanges: moment(startDate).format('MM-DD-YYYY'),
          enddatechanges: moment(endDate).format('MM-DD-YYYY')
        };
      }
    }
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }

  get disabledBtnSave(): boolean {
    return (this.selectedProvider === this.companyId && !this.isPosting) || this.disableButton;
  }

  postTripAssignment(): void {
    if(!this.isPosting) {
      this.sweetAlertHelper.createCustomAlert({
        text: 'Do you want to Post the Assignment of the Trips Now?',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(res => {
        if (!res.value) {
          this.isPosting = false;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reservation-change-provider/reservation-change-provider.component.ts